(function () {
  const STORAGE_KEY = 'wishlistItem';

  const drawer = document.getElementById('wishlist-drawer');
  const overlay = document.getElementById('wishlist-drawer-overlay');
  const closeBtn = document.getElementById('wishlist-drawer-close');
  const itemsList = document.getElementById('wishlist-items');
  const emptyMsg = document.getElementById('wishlist-empty');
  const loadingMsg = document.getElementById('wishlist-loading');

  let loaded = false;

  function updateBadge() {
    const handles = getHandles();
    const count = handles.length;

    const countEl = document.querySelector('[data-wishlist-count]');
    if (!countEl) return;

    if (count > 0) {
      countEl.textContent = count > 99 ? '99+' : count;
      countEl.classList.remove('loading'); // 移除隐藏类，数字显示出来
    } else {
      countEl.textContent = '0';
      countEl.classList.add('loading'); // 加回隐藏类，数字消失
    }
  }



  function openDrawer() {
    updateBadge(); // 加这行
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!loaded) {
      loadItems();
      loaded = true;
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function loadItems() {
    loadingMsg.style.display = 'block';
    itemsList.style.display = 'none';
    emptyMsg.style.display = 'none';

    const handles = getHandles();

    if (handles.length === 0) {
      loadingMsg.style.display = 'none';
      emptyMsg.style.display = 'flex';
      return;
    }

    const products = await Promise.all(handles.map(fetchProduct));
    const valid = products.filter(Boolean);

    loadingMsg.style.display = 'none';

    if (valid.length === 0) {
      emptyMsg.style.display = 'flex';
      return;
    }

    itemsList.innerHTML = '';
    valid.forEach((product) => {
      const variant = product.variants[0];
      const image = product.featured_image || '';
      const price = formatMoney(variant.price);
      const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price)
        : null;

      const li = document.createElement('li');
      li.className = 'wishlist-item';
      li.innerHTML = `
        <a class="wishlist-item__image-wrap" href="/products/${product.handle}">
          <img class="wishlist-item__image" src="${image}" alt="${product.title}" loading="lazy">
        </a>
        <div class="wishlist-item__info">
          <a class="wishlist-item__title" href="/products/${product.handle}">${product.title}</a>
          <div class="wishlist-item__price-wrap">
            ${comparePrice ? `<span class="wishlist-item__compare-price">${comparePrice}</span>` : ''}
            <span class="wishlist-item__price">${price}</span>
          </div>
          <button class="wishlist-item__atc" data-variant-id="${variant.id}">加入购物车</button>
        </div>
        <button class="wishlist-item__remove" data-handle="${product.handle}" aria-label="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      `;
      itemsList.appendChild(li);
    });

    itemsList.style.display = 'block';

    // 删除按钮
    itemsList.querySelectorAll('.wishlist-item__remove').forEach((btn) => {
      btn.addEventListener('click', function () {
        removeItem(this.dataset.handle);
        this.closest('.wishlist-item').remove();
        if (itemsList.children.length === 0) {
          itemsList.style.display = 'none';
          emptyMsg.style.display = 'flex';
        }
      });
    });

    // 加入购物车
    itemsList.querySelectorAll('.wishlist-item__atc').forEach((btn) => {
      btn.addEventListener('click', async function () {
        const variantId = this.dataset.variantId;
        this.textContent = '添加中...';
        this.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          this.textContent = '已加入 ✓';
          // 触发购物车更新（兼容大多数主题）
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (e) {
          this.textContent = '失败，重试';
          this.disabled = false;
        }
      });
    });
  }

  function removeItem(handle) {
    let handles = getHandles();
    handles = handles.filter((h) => h !== handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    loaded = false; // 下次打开重新加载
    updateBadge(); // 加这行
  }

  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay && overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // 拦截底部导航 Wishlist 点击
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="wishlist"]');
    if (link) {
      e.preventDefault();
      openDrawer();
    }
  });

  window.WishlistDrawer = { open: openDrawer, close: closeDrawer };

  // 页面加载时立即显示角标（延迟确保 DOM 就绪）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadge);
  } else {
    setTimeout(updateBadge, 300);
  }

})();

